// Transforme les filtres AG Grid en format "search_xxx"
const parseFilters = (filterModel) => {
  const filters = {};
  if (!filterModel) return filters;

  Object.keys(filterModel).forEach((key) => {
    // REGLE 1 : On ajoute le préfixe "search_" devant chaque champ
    filters[`search_${key}`] = filterModel[key].filter;
  });
  return filters;
};

// Transforme le tri
const parseSort = (sortModel) => {
  if (!sortModel || !sortModel.length) return null;
  const { colId, sort } = sortModel[0];
  return sort === "desc" ? `-${colId}` : colId;
};

export { parseSort, parseFilters };
